<template>
  <div class="tips-info">
    <i class="el-icon-info"></i>
    <span class="txt">{{ tips }}</span>
  </div>
</template>
<script>
export default {
  name: 'TipsInfo',
  props: {
    tips: {
      type: String,
      default: ''
    }
  }
}
</script>
<style lang="scss" scoped>
  .tips-info {
    display: flex;
    padding: 7px 0;
    background-color: #f2fbff;
    border: 1px solid #ccecff;
    width: calc(100% - 40px);
    margin: 10px auto;
    border-radius: 4px;

    .el-icon-info {
      color: #1b9aee;
      font-size: 16px;
      line-height: 16px;
      margin: 2px 8px 0 10px;
    }

    .txt {
      font-size: 14px;
      line-height: 20px;
    }
  }
</style>
